import React, { useState, useEffect } from "react";
import "./OrdersTable.css";
import DataTable from "../../components/common/DataTable/DataTable";
import { useGetOrdersByTypeQuery } from "./orderSlice";
import LoadingSpinner from "../../components/common/LoadingSpinner/LoadingSpinner";
import { selectCurrentUser } from "./../auth/authSlice";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";

const CustomerStatusCell = ({ customerStatus }) =>
  customerStatus ? (
    <input type="checkbox" className="green-checkbox" checked disabled />
  ) : (
    <input type="checkbox" className="green-bordered" disabled />
  );

function currencyFormatter(value) {
  if (value !== null && value !== "" && value !== undefined) {
    return value.toLocaleString("en-GB", { style: "currency", currency: "GBP" });
  }
}

const orderHeading = [
  { name: "Date", selector: (row) => row.orderDate, sortable: true },
  { name: "Initials", selector: (row) => row.orderTag, sortable: true },
  { name: "Enquiry Ref.", selector: (row) => row.enquiry, sortable: true },
  { name: "Client Name", selector: (row) => row.customerName, sortable: true },
  {
    name: "New Client",
    selector: (row) => row.customerStatus,
    sortable: true,
    cell: (row) => <CustomerStatusCell customerStatus={row.customerStatus} />,
  },
  {
    name: "Amount",
    selector: (row) => row.orderAmount,
    sortable: true,
    cell: (row) => currencyFormatter(row.orderAmount),
    style: { justifyContent: "end" },
  },
];

const OrdersTable = ({ handleFilter, handleEmployeeSelection }) => {
  const user = useSelector(selectCurrentUser);

  const [userId, setUserId] = useState(user.userID);

  function getUserId(value) {
    setUserId(value);
  }

  const [type, setType] = useState("month");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  function handleChildClick(value, startDate, endDate) {
    setType(value);
    setStartDate(startDate);
    setEndDate(endDate);
    handleFilter(value, startDate, endDate);
  }

  const {
    data: orders,
    isLoading,
    error,
    refetch,
  } = useGetOrdersByTypeQuery({
    type: type,
    startDate: startDate,
    endDate: endDate,
  });

  const [orderData, setOrderData] = useState([]);


  useEffect(() => {
    if (orders) {
      const data = orders.ids.map((id) => {
        return orders.entities[id];
      });
      setOrderData(data);
    }
    if (error) {
      toast.error(
        `Fetching orders failed: ${error?.data?.Message || error?.data?.title} `
      );
    }
  }, [orders, error]);

  return (
    <div>
      {isLoading && <LoadingSpinner />}
      <DataTable
        type={"orders"}
        allData={orderData}
        tableHeading={orderHeading}
        itemsPerPage={orderData.length}
        newOption={1}
        getUserId={getUserId}
        handleFilter={handleChildClick}
        refetch={refetch}
        handleEmployee={handleEmployeeSelection}
      />
    </div>
  );
};

export default OrdersTable;
